webpackJsonp([184662623972074],{

/***/ 481:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<h3>Name, Email, Message</h3>","frontmatter":{"title":"Contact"}}},"pathContext":{"id":"/opt/build/repo/src/pages/contact/index.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---contact-3e61d24dab6cd4684707.js